export default __webpack_public_path__ + "static/media/biomed-briqutte-icon.27d4130b.svg";